/**
 * Contratos compartilhados entre `@apen/api` e `@apen/web`.
 *
 * Tudo que atravessa a rede passa por aqui. O mesmo schema zod valida a entrada
 * no Fastify e a resposta no React: quando o formato de uma rota muda, os dois
 * lados quebram no build, e nao em producao.
 */
export * from './primitives.js';
export * from './categories.js';
export * from './plano.js';
export * from './patrimoniais.js';
export * from './exportacao.js';
export * from './transactions.js';
export * from './auth.js';
export * from './totp.js';
export * from './banks.js';
export * from './screens.js';
export * from './blocos.js';
export * from './bancos-br.js';
export * from './planilhas.js';
export * from './balanco.js';
export * from './extratos.js';
export * from './empresas.js';

/** Nome dos cookies e cabecalhos, para os dois lados nunca divergirem. */
export const SESSION_COOKIE = 'token';
export const CSRF_COOKIE = 'csrf_token';
export const CSRF_HEADER = 'x-csrf-token';

/** Sessao de 12h, igual ao sistema legado. */
export const SESSION_MAX_AGE_MS = 12 * 60 * 60 * 1000;

/** Formato de erro devolvido por qualquer rota da API. */
export interface ApiError {
  message: string;
  /** Presente apenas em falha de validacao, campo a campo. */
  issues?: { path: string; message: string }[];
}
